import { render, staticRenderFns } from "./PersonalityAssessmentWrapper.vue?vue&type=template&id=4e595051&scoped=true&"
import script from "./PersonalityAssessmentWrapper.vue?vue&type=script&lang=ts&"
export * from "./PersonalityAssessmentWrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e595051",
  null
  
)

export default component.exports